import { calendar_event } from "@/app/typing/events";
import { ChatEntryList } from "./chatEntryList";
import { deleteEvent } from "@/api/sdk.gen";
import { useEffect, useRef, useState } from "react";
import { scrollIntoContainer } from "@/components/scrollUtils";

const ChatEventList = (params: { events: calendar_event[], tool_use_id?: string, intent?: string }) => {

    const containerRef = useRef<HTMLDivElement>(null);
    const [highlightedId, setHighlightedId] = useState<number | null>(null);

    useEffect(() => {
        const handleCitationHover = (e: CustomEvent) => {


            if (e.detail.citationType == "event") {
                const { event_id, action } = e.detail;

                if (action === 'enter') {
                    setHighlightedId(event_id);
                } else if (action === 'leave') {
                    setHighlightedId(null);
                }

            }
        };

        const handleCitationClick = (e: CustomEvent) => {

            const { event_id } = e.detail;

            if (e.detail.citationType == "event") {

                const element = containerRef.current?.querySelector(`[data-item-id="${event_id}"]`);
                if (element) {
                    setHighlightedId(event_id);
                    setTimeout(() => element.scrollIntoView({ behavior: 'smooth', block: 'center' }), 100);
                }

            }

        };

        document.addEventListener('citation-hover', handleCitationHover as EventListener);
        document.addEventListener('citation-click', handleCitationClick as EventListener);

        return () => {
            document.removeEventListener('citation-hover', handleCitationHover as EventListener);
            document.removeEventListener('citation-click', handleCitationClick as EventListener);
        };
    }, [params.tool_use_id]);


    return (
        <div className="w-full" ref={containerRef}>
            <ChatEntryList
                items={params.events.map(ev => ({ ...ev }))}
                object_type="event"
                intent={params.intent}
                extractDisplayValue={(ev) => ev.title}
                extractId={(ev) => ev.id}
                deleteFunction={(ids) => Promise.all(ids.map(id => deleteEvent({ body: { id } }))).then(() => undefined)}
                routePath="/workspace/events"
                containerClassName="h-full w-full max-h-[16em] overflow-y-auto"
                debugMessage="mount events"
                highlightedId={highlightedId}
            />
        </div>
    );
};

export default ChatEventList;
